export const isSkillMarkdownRelativeLink = (href: string): boolean =>
  !href.startsWith("http://") &&
  !href.startsWith("https://") &&
  !href.startsWith("mailto:") &&
  !href.startsWith("#");

export const resolveSkillMarkdownRelativePath = (
  currentPath: string | null,
  href: string,
): string | null => {
  const cleanHref = href.split("#")[0]?.trim() ?? "";
  if (!cleanHref) {
    return null;
  }

  const inputParts = cleanHref.replace(/^\/+/, "").split("/").filter(Boolean);
  let baseParts: string[] = [];
  if (!cleanHref.startsWith("/") && currentPath) {
    baseParts = currentPath.split("/").slice(0, -1);
  }

  const resolved: string[] = [...baseParts];
  inputParts.forEach((part) => {
    switch (part) {
      case ".":
        return;
      case "..":
        resolved.pop();
        return;
      default:
        resolved.push(part);
    }
  });

  return resolved.join("/");
};
